<template>
  <side-panel-inner
    :headerTitle="editMode ? 'Edit Category' : 'Create a Category'"
    class="p-category-create"
  >

    <template v-if="editMode" slot="actions">
      <base-button
        :danger="true"
        button-style="danger"
        @click="deleteCategory"
        iconBefore="delete"
      >Delete</base-button>
      <base-button success :primary="true" @click="onFormSubmit">Save</base-button>
    </template>

    <template v-else slot="actions">
      <base-button :primary="true" @click="onFormSubmit">Create</base-button>
    </template>

    <!-- Category Name -->
    <message type="error" v-if="showValidationMessage">
      <h3>Form Invalid</h3>
      <p>Form is invalid, please check and try again.</p>
    </message>

    <category-form ref="form" v-if="!loading && formReady" :newsCategory="newsCategory"></category-form>

    <loading v-if="loading"></loading>
  </side-panel-inner>
</template>

<script>
import CategoryForm from './CategoryForm';

export default {
  name: 'category-edit-create',

  data() {
    return {
      showValidationMessage: false,
      editMode: false,
      loading: false,
      formReady: false,
      editMode: false,
      formReady: false,
    };
  },

  beforeMount() {
    const categoryId = this.$route.params.id;
    if (categoryId) {
      this.editMode = true;
      this.$store.dispatch('NewsCategories/read', categoryId).then(() => {
        this.formReady = true;
      });
    } else {
      this.formReady = true;
    }
  },

  methods: {
    onFormSubmit() {
      const vm = this;

      vm.$refs.form.$validator.validate().then((result) => {
        if (!result) {
          vm.showValidationMessage = true;
        } else {
          vm.showValidationMessage = false;
          vm.editMode ? vm.updateCategory() : vm.createCategory();
        }
      });
    },

    createCategory() {
      const vm = this;
      this.$store
        .dispatch('NewsCategories/create', { ...vm.newsCategory })
        .then(() => {
          vm.$store.dispatch('CLOSE_PANEL');
        });
    },

    updateCategory() {
      const vm = this;
      vm.$store
        .dispatch('NewsCategories/update', { ...vm.newsCategory })
        .then(() => {
          vm.$store.dispatch('CLOSE_PANEL');
        });
    },

    deleteCategory() {
      const vm = this;
      this.$store.dispatch('createDialog', {
        confirm: () => {
          vm.$store
            .dispatch('NewsCategories/delete', vm.$route.params.id)
            .then(() => {
              // vm.$store.dispatch("CLOSE_PANEL");
            });
        },
      });
    },
  },

  computed: {
    formIsValid() {
      return this.category.name;
    },
    newsCategory: {
      get() {
        return this.$store.state.NewsCategories.category;
      },
      set(newVal) {
        this.newsCategoryData = newVal;
      },
    },
  },

  components: {
    CategoryForm,
  },
};
</script>
